export const pendoTikTokReport = '[Report hub] Generate TikTok report';
